import { Component, OnInit } from '@angular/core';
import { MatCardModule, MatFormFieldModule, MatInputModule, MatButtonModule } from '@angular/material/';

import { HelperService } from '../service/helper/helper.service';
import { AuthService } from '../service/auth/auth.service';
import { Router } from '@angular/router';


@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

	view;
	pk: any;
	data: any = {};
	constructor(public router: Router, public helper: HelperService, public auth: AuthService) { }
	ngOnInit() {
		if (localStorage.getItem("nesten_hd") === null) {
			this.view = 1;
		} else {
			this.view = 3;
		}
	}
	route(linkName) {
		const link = ['/' + linkName];
		this.router.navigate(link);
	}

	goView(no) {
		this.view = no;
	}

	signup() {
		// if (this.data.password != this.data.repassword) {
		// 	alert('password not matched');
		// 	this.data.password = '';
		// 	this.data.repassword = ''
		// 	return;
		// }
		// this.helper.globalPassword = this.data.password;
		this.view = 1;
		//this.HelperService.login(this.data.password);
	}
  login() {
    this.view = 1;
  }
	access() {
		this.helper.loadWalletWithSeedWord(this.data.password).then((response) => {
			if(!response){
				this.data.password = ''
			}
		})
		// this.view = 1;
		//this.HelperService.login(this.data.password);
	}
}
